import { RegularButton } from "@components/buttons"
import { Modal } from "@components/modal"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/pictures"
import AuthServices from "@lib/api/services/auth.services"
import { useUserData } from "@lib/context/ComponentContext"
import clsx from "clsx"
import Image from "next/image"
import { useRouter } from "next/router"
import React, { FC, useState } from "react"
import { useForm } from "react-hook-form"
import { AiOutlineClose } from "react-icons/ai"
import { FaTimes } from "react-icons/fa"

export interface NotVerifiedEmailModalProps {
  onHide: any
  show: boolean
}
export const NotVerifiedEmailModal: FC<NotVerifiedEmailModalProps> = ({ onHide, show }) => {
  const [successModal, setSuccessModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const auth = new AuthServices()
  const { tokenData } = useUserData()
  const { asPath } = useRouter()

  const { handleSubmit } = useForm({
    mode: "onSubmit",
  })

  const onSubmit = async () => {
    try {
      setErrorMessage("")
      setIsSubmitting(true)
      //  click email verification
      await auth.resendVerificationEmail(tokenData?.user_email as string, `/school/${asPath}`)
      onHide()
      setSuccessModal(true)
      setErrorMessage("")
      return setIsSubmitting(false)
    } catch (error) {
      setErrorMessage("Terjadi Kesalahan. Silahkan Coba lagi")
      return setIsSubmitting(false)
    }
  }

  return (
    <>
      <Modal
        show={show}
        onClose={onHide}
        contentPadding="sm:p-8 p-5"
        customCloseButton={
          <button
            className={clsx("absolute sm:text-xl sm:top-9 sm:right-8", "text-lg top-6 right-5")}
            onClick={onHide}
          >
            <AiOutlineClose />
          </button>
        }
        contentClassName="rounded-none sm:min-w-[45vw]"
      >
        <Image
          width={360}
          height={240}
          className="mx-auto"
          src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/popup_not-verified.png`}
          alt="icon"
        />
        <div className="font-bold sm:text-2xl text-xl sm-only:w-[90%] text-center font-urbanist">
          Oops! Email Kamu Belum Terverifikasi
        </div>
        <center className="font-inter">
          Akun kamu belum diverifikasi. Silahkan login ulang jika kamu telah melakukan verifikasi.
        </center>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
          {errorMessage && <div className="text-red">{errorMessage}</div>}
          <RegularButton
            className={clsx("sm:w-fit mx-auto")}
            variant="solid-blue"
            isFormik
            isSubmitting={isSubmitting}
          >
            Verifikasi Email
          </RegularButton>
        </form>
      </Modal>

      <Modal show={successModal} onClose={() => setSuccessModal(false)}>
        <button
          className={clsx("flex top-2.5 right-2.5 absolute z-[888] align-end")}
          onClick={() => setSuccessModal(false)}
        >
          <FaTimes />
        </button>
        <div className="text-center max-w-xl p-8">
          <div className="font-bold text-2xl">Email verifikasi sudah dikirim</div>
          <div className="text-grey-97 text-base mt-2">
            Silahkan cek kotak masuk email untuk langkah lebih lanjut.
          </div>
        </div>
      </Modal>
      {/* <InstallmentSuccessModal show={successModal} onHide={() => setSuccessModal(false)} /> */}
    </>
  )
}
